const ratesMaps = [
    { key: 40, value: "LTV_0_40" },
    { key: 45, value: "LTV_0_45" },
    { key: 50, value: "LTV_0_50" },
    { key: 54, value: "LTV_0_54" },
    { key: 55, value: "LTV_0_55" },
    { key: 60, value: "LTV_0_60" },
    { key: 61, value: "LTV_0_61" },
    { key: 65, value: "LTV_0_65" },
    { key: 66, value: "LTV_0_66" },
    { key: 67.5, value: "LTV_0_675" },
    { key: 70, value: "LTV_0_70" },
    { key: 71, value: "LTV_0_71" },
    { key: 75, value: "LTV_0_75" },
    { key: 80, value: "LTV_0_80" },
    { key: 81, value: "LTV_0_81" },
    { key: 85, value: "LTV_0_85" },
    { key: 88, value: "LTV_0_88" },
    { key: 90, value: "LTV_0_90" },
    { key: 91, value: "LTV_0_91" },
    { key: 95, value: "LTV_0_95" },
    { key: 100, value: "LTV_1_00" },
    { key: 101, value: "LTV_1_01" },
    { key: 102, value: "LTV_1_02" },
    { key: 103, value: "LTV_1_03" },
    { key: 104, value: "LTV_1_04" },
    { key: 105, value: "LTV_1_05" },
    { key: 106, value: "LTV_1_06" },
    { key: 108, value: "LTV_1_08" },
    { key: 110, value: "LTV_1_10" },
    { key: 112.5, value: "LTV_1_125" },
    { key: 115, value: "LTV_1_15" },
    { key: 120, value: "LTV_1_20" }
];

const nhgMap = [{ key: 90, value: "NHG90" }, { key: 90.01, value: "NHG" }];

const getRateKey = (hasNHG, ltvValue) => {
    const list = hasNHG ? nhgMap : ratesMaps;

    for (let index = 0; index < list.length; index++) {
        const rate = list[index];
        if (ltvValue <= rate.key) {
            return rate.value;
        }
    }

    return list[list.length - 1].value;
};

export default getRateKey;
